import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import './quizeTopicSelect.scss'
import closeIcon from '../../assets/icons/close.svg'
import accordianArrow from '../../assets/icons/accordion.svg'
import Checkbox from '@mui/material/Checkbox'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { createPracticeExam } from '../../store/builders/studentCourse/studentCourseDashboard.builder'
import { capitalizeFirstLetter } from '../../utility/genricFunction'

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(() => ({
  'backgroundColor': '#f4f5fb',
  'padding': 0,
  'border': `1px solid #E2EAED`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
  '& .MuiAccordionDetails-root': {
    padding: 0,
    borderTop: 'none',
  },
  '& .MuiPaper-root MuiPaper-elevation': {
    padding: '0 21px',
    minWidth: '100%',
    backgroundColor: 'red',
  },
}))

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary expandIcon={<img src={accordianArrow} alt='' />} {...props} />
))(({ theme }) => ({
  'flexDirection': 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(-180deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
    justifyContent: 'space-between',
  },
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}))

function QuizeTopicSelect({ onclose, data }) {
  const [parentExpanded, setParentExpanded] = useState('')
  const [selectedModule, setSelectedModule] = useState([])
  const [selectedTopics, setSelectedTopics] = useState([])
  const dispatch = useDispatch()

  const handleParentChange = (panel) => (event, newExpanded) => {
    setParentExpanded(newExpanded ? panel : false)
  }

  const handleSelectAll = (moduleIndex, module) => {
    const moduleTopics = data[moduleIndex].topics.map((topic) => topic.courseModuleTopicId)
    const allSelected = moduleTopics.every((topicId) => selectedTopics.includes(topicId))

    const newSelectedTopics = allSelected
      ? selectedTopics.filter((topicId) => !moduleTopics.includes(topicId))
      : [...selectedTopics, ...moduleTopics.filter((topicId) => !selectedTopics.includes(topicId))]

    setSelectedTopics(newSelectedTopics)

    if (!allSelected && !selectedModule.includes(module)) {
      setSelectedModule([...selectedModule, module])
    } else if (allSelected) {
      setSelectedModule(selectedModule.filter((selectedModuleItem) => selectedModuleItem !== module))
    }
  }

  const handleTopicSelect = (moduleIndex, topicId, module) => {
    const isSelected = selectedTopics.includes(topicId)

    const newSelectedTopics = isSelected
      ? selectedTopics.filter((selectedTopicId) => selectedTopicId !== topicId)
      : [...selectedTopics, topicId]

    setSelectedTopics(newSelectedTopics)

    const moduleTopics = data[moduleIndex].topics.map((topic) => topic.courseModuleTopicId)
    const anySelected = moduleTopics.some((topicId) => newSelectedTopics.includes(topicId))

    if (anySelected && !selectedModule.includes(module)) {
      setSelectedModule([...selectedModule, module])
    } else if (!anySelected) {
      setSelectedModule(selectedModule.filter((selectedModuleItem) => selectedModuleItem !== module))
    }
  }

  const isAllSelected = (moduleIndex) => {
    const moduleTopics = data[moduleIndex].topics.map((topic) => topic.courseModuleTopicId)
    return moduleTopics.every((topicId) => selectedTopics.includes(topicId))
  }

  const isTopicSelected = (topicId) => {
    return selectedTopics.includes(topicId)
  }

  const navigate = useNavigate()

  function StartPractice() {
    const data = {
      courseModuleIds: selectedModule,
      courseModuleTopicIds: selectedTopics,
      navigate 
    }
    dispatch(createPracticeExam(data))
    // navigate('/student-practice')
  }

  return (
    <Box className='timetable-drawer' role='presentation'>
      <div className='select-module-wrapper'>
        <div className='select-module-header'>
          <div className='header-left-div'>
            <p>Select Module</p>
            <span>Select modules to start practice</span>
          </div>
          <img className='close-icon' src={closeIcon} alt='Close' onClick={onclose(false)} />
        </div>
        <Box className='drawer-horizontal-line' />
        <span className='all-modules-span'>All Modules</span>
        <div className='accordion-select-wrapper'>
          {data?.map((module, moduleIndex) => (
            <Accordion
              key={moduleIndex}
              expanded={parentExpanded === `panel${moduleIndex}`}
              onChange={handleParentChange(`panel${moduleIndex}`)}
              className='accordion'
            >
              <AccordionSummary aria-controls={`panel${moduleIndex}d-content`} id={`panel${moduleIndex}d-header`}>
                <Typography className='accordion-header'>{capitalizeFirstLetter(module.courseModuleName)}</Typography>
                <Typography className='accordion-detail'>
                  Select All
                  <Checkbox
                    checked={isAllSelected(moduleIndex)}
                    onChange={() => handleSelectAll(moduleIndex, module.courseModuleId)}
                    className='checkbox'
                  />
                </Typography>
              </AccordionSummary>
              <AccordionDetails className='accordion-topic-name'>
                {module.topics.map((topic, topicIndex) => (
                  <div className='topic-row' key={topicIndex}>
                    <p>{capitalizeFirstLetter(topic.courseModuleTopicName)}</p>
                    <Checkbox
                      checked={isTopicSelected(topic.courseModuleTopicId)}
                      onChange={() => handleTopicSelect(moduleIndex, topic.courseModuleTopicId, module.courseModuleId)}
                      className='checkbox'
                    />
                  </div>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
        <div className='start-practice-button-div'>
          <button
            className='start-practice button'
            disabled={!selectedTopics || !selectedTopics.length}
            onClick={StartPractice}
          >
            Start Practice
          </button>
        </div>
      </div>
    </Box>
  )
}

export default QuizeTopicSelect
